    <!-- <div *ngIf="option=='save' || option == 'update' ">
    <input type="text" placeholder="minTemplateName"  matInput [(ngModel)]="minTemplateName">
    <mat-radio-group required aria-label="Select an option" [(ngModel)]="status">
        <mat-radio-button class="matButton"  value="Private" >Private</mat-radio-button>
        <mat-radio-button class="matButton"  value="Public">public</mat-radio-button>
        <mat-radio-button class="matButton"  value="Self">Self</mat-radio-button>
    </mat-radio-group>
    <button *ngIf="option=='save'" (click)="saveTemplate('true')">save</button>
    <button *ngIf="option=='update'" (click)="saveTemplate('false')">Update</button>
    <button *ngIf="option=='update'" (click)="saveTemplate('true')">SaveAsNewTemplate</button>
    </div>
   
    <div *ngIf="option=='edit'">
    <mat-form-field appearance="outline">
        <mat-label>Templates</mat-label>
        <mat-select (selectionChange)="filterCondition($event)" required>
          <mat-option  *ngFor="let temp of templates" [value]="temp">
            {{temp.minTemplateName}}
          </mat-option>
        </mat-select>     
      </mat-form-field>
    </div>    -->


    <div class = "dialog-header-container">
      <h2 *ngIf="option=='categoryUpdate'" mat-dialog-title class="mar-b-5 pd-t-5px">Choose Template</h2>
      <h2 *ngIf="option!='categoryUpdate'" mat-dialog-title class="mar-b-5 pd-t-5px">{{this.option=='save'?'Save Template':'Edit Template'}}</h2>
      <div> 
        <button mat-icon-button mat-dialog-close>
          <mat-icon>
            close
          </mat-icon>
        </button>
      </div>
    </div>
    <div class="loading-indicator">
      <mat-progress-spinner mode="indeterminate"  *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25' strokeWidth='3'></mat-progress-spinner>
    </div>
    <mat-divider class="mat-divider"></mat-divider>
    <form *ngIf="option!='categoryUpdate'" class="example-form" [formGroup]="templateForm" (ngSubmit)="saveMinutesTemplate()" [hidden]="isLoading">
      <div mat-dialog-content class="dialog-with-actions" [ngStyle]="{'margin-top':'10px'}">
        <mat-form-field *ngIf="option=='save' || option == 'update' " class="example-full-width w-100 mt-10" >
          <mat-label>Template Name <span class="asterik-class">&nbsp;*</span></mat-label>
          <input matInput value="" formControlName="minTemplateName">
          <mat-error *ngIf="isSubmitted && formControls.minTemplateName.errors && formControls.minTemplateName.errors.required">Template Name is required</mat-error>
        </mat-form-field>
        <!-- <div *ngIf="isSubmitted && formControls.minTemplateName.errors" class="help-block">
          <div *ngIf="formControls.minTemplateName.errors.required" class="validateFont">Template Name is required</div>
        </div> -->
        <mat-form-field class="w-100" [attr.disabled]="true" id = "category-selectone-field">
            <mat-label id = "category-selectone" >Select Category <span class="asterik-class">&nbsp;*</span></mat-label>
            <mat-select [(ngModel)]="selected" disableOptionCentering panelClass="common-drop-down-class" formControlName="categoryStates" id = "category-select" (selectionChange)="filterCategory($event)" >
              <mat-option  *ngFor="let state of categoryType" [value]="state.codeId">{{state.description}}</mat-option>
            </mat-select>
            <mat-error *ngIf="categoryError && isSubmitted && formControls.categoryStates.errors && formControls.categoryStates.errors.required">Please Select Category</mat-error>
        </mat-form-field>

      <mat-form-field *ngIf="option=='edit' && templateList.length != 0" class="w-100" [attr.disabled]="true" id = "category-selectone-field">
        <mat-label id = "category-selectone" >Select Template <span class="asterik-class">&nbsp;*</span></mat-label>
        <mat-select [(ngModel)]="selected" disableOptionCentering panelClass="common-drop-down-class" formControlName="templateState" id = "category-select" (selectionChange)="filterCondition($event)"  >
          <mat-option  *ngFor="let state of templateList" [value]="state" [disabled]="state.minTemplateId==1">{{state.minTemplateName}}</mat-option>
        </mat-select>
        <mat-error *ngIf="categoryError && isSubmitted && formControls.categoryStates.errors && formControls.categoryStates.errors.required">Please Select template</mat-error>
    </mat-form-field>
        <!-- <div *ngIf="categoryError && isSubmitted && formControls.categoryStates.errors" class="help-block">
            <div *ngIf="formControls.categoryStates.errors.required" class="validateFont">Please Select Category</div>
        </div> -->
        <div *ngIf="option=='save' || option == 'update'" mat-dialog-actions class="d-flex justify-content-end">
            <mat-form-field  *ngIf = "categoryShow" id="tempCreate" class="example-full-width w-100 mt-1 creatTempl">
                <mat-label>Category Name<span class="asterik-class">&nbsp;*</span></mat-label>
                <input matInput value="" formControlName="categoryName">
                <!-- <div *ngIf="categoryShow && isSubmitted && formControls.categoryName.errors">               -->
                  <mat-error *ngIf="categoryShow && isSubmitted && formControls.categoryName.errors && formControls.categoryName.errors.required">Category Name is required</mat-error>
                <!-- </div> -->
              </mat-form-field>
              <!-- <div *ngIf="categoryShow && isSubmitted && formControls.categoryName.errors" class="category-block">
                <div *ngIf="formControls.categoryName.errors.required" class="validateFont">Category Name is required</div>
              </div> -->
                <button [attr.disabled]="true" id = "category-btn" class="button-container primary" type="button" mat-flat-button [ngStyle]="{'color':'#ffffff'}" (click)="isopenCategory(categoryName)">
                    Add Category
                </button>              
        </div>
        <div [ngStyle]="{'margin-top':'20px'}">
          <mat-form-field class="example-full-width w-100" *ngIf="option=='save' || option == 'update'" [ngStyle]="{'margin-top':'5px'}"> 
              <mat-label>Template Description</mat-label>
              <textarea matInput placeholder="" formControlName="templateDesc"></textarea>
          </mat-form-field>
        </div>
          <!-- <div *ngIf="isSubmitted && formControls.templateDesc.errors" class="help-block">
            <div *ngIf="formControls.templateDesc.errors.required" class="validateFont">Template Description is required</div>
          </div> -->
        <div>
          <div *ngIf="option=='save' || option == 'update'">
            <mat-radio-group required aria-label="Select an option" [(ngModel)]="type" formControlName="type">
              <mat-radio-button class="matButton" [checked]='type =="Public"' value="Public" [ngStyle]="{'margin-right':'5px'}">Public</mat-radio-button>
              <mat-radio-button class="matButton" [checked]='type =="Private"' value="Private" [ngStyle]="{'margin-right':'5px'}">Private</mat-radio-button>
              <mat-radio-button class="matButton" [checked]='type =="Anyone"' value="Anyone" [ngStyle]="{'margin-right':'5px'}">Anyone</mat-radio-button>
          </mat-radio-group>
          </div>
            <!-- <div [ngStyle]="{'margin-bottom':'10px'}">
               <mat-checkbox class="example-margin" formControlName="participants">Include Attendee(s)</mat-checkbox>
            </div> -->
            <!-- <div [ngStyle]="{'margin-bottom':'10px'}">
               <mat-checkbox class="example-margin" formControlName="notes">Include Notes</mat-checkbox>
            </div> -->
        </div>
      </div>
      <div mat-dialog-actions class="d-flex justify-content-end">
        <!-- <span><button class="button-container primary" type="button" mat-flat-button color="primary" (click)="cancelMeeting()">Save</button></span>&nbsp;&nbsp;
        <span> (click)="saveMeetingTemplate(templateForm.value)"-->
            <button *ngIf="option=='save'" class="button-container primary" type="submit" mat-flat-button color="primary">
                SAVE
            </button>
            <button *ngIf="option=='update'"  class="button-container primary" type="submit" mat-flat-button color="primary">
              UPDATE
          </button>
            <button type="button" #editModalClose mat-flat-button color="primary" class="button-container primary" mat-dialog-close>
                CANCEL
            </button>
      </div>
    </form>
    <div *ngIf="option=='categoryUpdate'">
      <mat-form-field class="w-100" [attr.disabled]="true" id = "category-selectone-field">
        <mat-label id = "category-selectone" >Select Template Category<span class="asterik-class"></span></mat-label>
        <mat-select [(ngModel)]="categoryId" disableOptionCentering panelClass="common-drop-down-class" id = "category-select" (selectionChange)="filterCategory($event)" >
          <mat-option  *ngFor="let state of categoryType" [value]="state.codeId">{{state.description}}</mat-option>
        </mat-select>
    </mat-form-field>
 
  <mat-form-field class="w-100" [attr.disabled]="true" id = "category-selectone-field">
    <mat-label id = "category-selectone" >Select Minutes Template <span class="asterik-class"></span></mat-label>
    <mat-select [(ngModel)]="minTemplateId" disableOptionCentering panelClass="common-drop-down-class" id = "category-select" (selectionChange)="onSubCategorySelect($event)"  >
      <mat-option  *ngFor="let state of templateList" [value]="state.minTemplateId">{{state.minTemplateName}}</mat-option>
    </mat-select>
</mat-form-field>
    </div>
    
    
    
  

